module.exports = __webpack_public_path__ + "static/media/Home Page_website-02.56682f58.png";